import * as React from 'react';
import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit/typography';

import { BankIcon } from './BankIcon';
import * as styles from './PromoItem.css';
import { PROMO_ICON } from '../../constants/promoIcon';
import { EPromoType, IPromoInfo } from '../../types/newbuilding/promoInfo';

interface IPromoItemProps {
  promo: IPromoInfo;
  onClick(): void;
}

export function PromoItem({ promo, onClick }: IPromoItemProps): React.JSX.Element {
  const { bank, promoType, name, subtitle } = promo;
  const icon = PROMO_ICON.get(promoType);

  return (
    <div className={styles['container']} onClick={onClick} data-testid="PromoItem">
      <div className={styles['icon']}>
        {promoType === EPromoType.Bank ? <BankIcon bank={bank} /> : <img src={icon} />}
      </div>
      <div>
        <div className={styles['title']}>
          <ArticleHeading4 as="h4">{name}</ArticleHeading4>
        </div>
        {subtitle && <ArticleParagraph2 color="text-secondary-default">{subtitle}</ArticleParagraph2>}
      </div>
    </div>
  );
}
